<template>
  <div id="home">
    <div class="header container">
      <LsHeader></LsHeader>
      <div class="introduces-row wow zoomIn">
        <div class="container container2" style="position:relative">
          <img class="title" src="../assets/images/title.png" />
          <!-- <img class="decorate" src="../assets/images/decorate.png" /> -->
          <p class="subtitle">10万+访员注册在线,调查从未如此简单</p>
          <div class="row">
            <div class="introduce flex">
              <img src="../assets/images/introduce-01.png" />
              <div>
                <p>专注社会调查{{year}}年</p>
                <p>年数据采集突破千万份</p>
              </div>
            </div>
            <div class="introduce flex">
              <img src="../assets/images/introduce-02.png" />
              <div>
                <p>降本增效 远程用工</p>
                <p>灵活就业、打破地域限制</p>
              </div>
            </div>
            <div class="introduce flex">
              <img src="../assets/images/introduce-03.png" />
              <div>
                <p>全程保障数据质量</p>
                <p>覆盖数据全生命周期</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row needs-row">
        <div class="container container2">
          <div class="need need-publish col-xs-12 col-md-7  wow slideInLeft">
            <p class="need-title">客户：我要发布调查需求</p>
            <div class="need-item flex">
              <img src="../assets/images/prefix-01.png" />
              {{year}}年调查经验
            </div>
            <div class="need-item flex">
              <img src="../assets/images/prefix-01.png" />
              1对1专属客服
            </div>
            <div class="need-item flex">
              <img src="../assets/images/prefix-01.png" />
              1000+政企客户认可
            </div>
            <div class="need-item flex">
              <img src="../assets/images/prefix-01.png" />
              全数据生命周期服务
            </div>
            <div class="ls-button need-button" @click="handleToRelease">
              发布需求
              <img src="../assets/images/button-icon-01.png" />
            </div>
            <div class="need-bg">
              <img src="../assets/images/need-bg-01.png" />
            </div>
          </div>
          <div class="need need-join col-xs-12 col-md-5 wow slideInRight">
            <p class="need-title">灵活就业者：我要加入数据蜂</p>
            <div class="need-item flex">
              <img src="../assets/images/prefix-01.png" />
              远程灵活就业
            </div>
            <div class="need-item flex">
              <img src="../assets/images/prefix-01.png" />
              足不出户挣钱
            </div>
            <div class="need-item flex">
              <img src="../assets/images/prefix-01.png" />
              时间自由管理
            </div>
            <div class="ls-button need-button need-register" @click="handleToDatabee">
              快速注册
              <img src="../assets/images/button-icon-02.png" />
            </div>
            <div class="need-bg">
              <img src="../assets/images/need-bg-02.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="title-divider text-center">
        <div class="title">CUSTOMERS POST TASKS</div>
        <div class="subtitle">
          <div class="left-divider"></div>
          发布调查需求
          <div class="right-divider"></div>
        </div>
      </div>
      <div class="container container2">
        <div class="row publish-row">
          <div class="col-md-6 col-sm-12 col-xs-12 publish">
            <p class="title">数据蜂云电话调查众包平台低成本、高效率的秘密</p>
            <p class="subtitle">省时：高速响应需求，10余年调研行业经验值得信赖</p>
            <p class="subtitle">省力：项目托管执行，无需自建呼叫中心和调研团队</p>
            <p class="subtitle">省钱：极大降低成本，无需机房设备及人员管理费用</p>
            <div class="flex btns-groups">
              <div class="ls-button need-button" @click="handleToRelease">
                发布需求
                <img src="../assets/images/button-icon-01.png" />
              </div>
              <div class="ls-button need-service" @mouseover="showContact = true" @mouseleave="showContact = false">
                业务咨询
                <img src="../assets/images/button-icon-03.png" />
              </div>
              <div class="ls-button-popup" v-if="showContact">
                <img src="../assets/qrcodes/1_Contact.png" />
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12 col-xs-12 wow slideInRight">
            <img src="../assets/images/publish.png" class="mockup" />
          </div>
        </div>
        <div class="row benefit-row wow slideInUp">
          <div class="benefit-box col-md-4 col-sm-12">
            <div class="benefit text-center">
              <img src="../assets/images/benefit-01.png" />
              <div class="title">专业团队保障数据科学</div>
              <div class="subtitle">跨学科专家团队定制调研方案</div>
              <div class="subtitle">严谨的研究方法，专业的抽样方案</div>
              <div class="subtitle">广泛的调查领域，丰富的项目执行经验</div>
            </div>
          </div>
          <div class="benefit-box col-md-4 col-sm-12">
            <div class="benefit text-center">
              <img src="../assets/images/benefit-02.png" />
              <div class="title">多维度的质控体系</div>
              <div class="subtitle">调查全程录音，审核更便捷</div>
              <div class="subtitle">访员动态评级，持续高质量访问</div>
              <div class="subtitle">逻辑校验结合访问时长，保证数据质量</div>
            </div>
          </div>
          <div class="benefit-box col-md-4 col-sm-12">
            <div class="benefit text-center">
              <img src="../assets/images/benefit-03.png" />
              <div class="title">动态可视分析与数据安全</div>
              <div class="subtitle">实现动态的数据可视化分析</div>
              <div class="subtitle">采用分布式存储进行多重数据备份</div>
              <div class="subtitle">基于管理角色设置权限，充分保障数据安全</div>
            </div>
          </div>
        </div>
      </div>
      <div class="title-divider text-center">
        <div class="title">USE CASES</div>
        <div class="subtitle">
          <div class="left-divider"></div>
          成功案例
          <div class="right-divider"></div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row case-row">
          <div class="case-box col-md-3 col-sm-6 col-xs-12">
            <div class="case">
              <div class="case-head">
                全国高校毕业生就业<br />状况核查
              </div>
              <div class="case-body">
                <div class="flex">
                  <img src="../assets/images/prefix-01.png" />
                  <div>
                    <div class="case-name">委托方：</div>
                    <div class="case-value">教育部学生司</div>
                  </div>
                </div>
                <div class="flex">
                  <img src="../assets/images/prefix-01.png" />
                  <div>
                    <div class="case-name">执行时间：</div>
                    <div class="case-value">2021年7月</div>
                  </div>
                </div>
                <div class="flex case-bot">
                  <img src="../assets/images/prefix-01.png" />
                  <div>
                    <div class="case-value">1000多名访员7小时完成13000多份问卷</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="case-box col-md-3 col-sm-6 col-xs-12">
            <div class="case">
              <div class="case-head case-head-02">
                武汉市“新冠”疫情<br />综合调查
              </div>
              <div class="case-body">
                <div class="flex">
                  <img src="../assets/images/prefix-01.png" />
                  <div>
                    <div class="case-name">委托方：</div>
                    <div class="case-value">西安交通大学医学部全球健康研究院</div>
                  </div>
                </div>
                <div class="flex">
                  <img src="../assets/images/prefix-01.png" />
                  <div>
                    <div class="case-name">执行时间：</div>
                    <div class="case-value">2020年5月</div>
                  </div>
                </div>
                <div class="flex case-bot">
                  <img src="../assets/images/prefix-01.png" />
                  <div>
                    <div class="case-value">武汉解封前执行全员核酸时，用5天时间调查近20000名武汉市民。是新冠疫情以来唯一的武汉市概率随机样本</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="case-box col-md-3 col-sm-6 col-xs-12">
            <div class="case">
              <div class="case-head case-head-03">
                北上广深四城市住房租赁<br />状况年度调查
              </div>
              <div class="case-body">
                <div class="flex">
                  <img src="../assets/images/prefix-01.png" />
                  <div>
                    <div class="case-name">委托方：</div>
                    <div class="case-value">中国人民大学首都发展研究院</div>
                  </div>
                </div>
                <div class="flex">
                  <img src="../assets/images/prefix-01.png" />
                  <div>
                    <div class="case-name">执行时间：</div>
                    <div class="case-value">2021年10月</div>
                  </div>
                </div>
                <div class="flex case-bot">
                  <img src="../assets/images/prefix-01.png" />
                  <div>
                    <div class="case-value">7天时间完成对北京、上海、广州、深圳6000多名租房居住市民的调查</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="case-box col-md-3 col-sm-6 col-xs-12">
            <div class="case">
              <div class="case-head case-head-04">
                慧育中国项目评估<br />调查
              </div>
              <div class="case-body">
                <div class="flex">
                  <img src="../assets/images/prefix-01.png" />
                  <div>
                    <div class="case-name">委托方：</div>
                    <div class="case-value">中国发展研究基金会</div>
                  </div>
                </div>
                <div class="flex">
                  <img src="../assets/images/prefix-01.png" />
                  <div>
                    <div class="case-name">执行时间：</div>
                    <div class="case-value">2020年7月</div>
                  </div>
                </div>
                <div class="flex case-bot">
                  <img src="../assets/images/prefix-01.png" />
                  <div>
                    <div class="case-value">5天时间访问了青海乐都和四川雷波26个乡镇1500多名参与干预实验项目儿童家长的调查</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="join">
      <div class="title-divider text-center">
        <div class="title">JOIN US</div>
        <div class="subtitle">
          <div class="left-divider"></div>
          加入数据蜂
          <div class="right-divider"></div>
        </div>
      </div>
      <div class="container container2">
        <div class="row publish-row">
          <div class="col-md-6 col-sm-12 col-xs-12 publish">
            <p class="title">数据蜂云电话调查众包平台—稳定收入，足不出户！</p>
            <p class="subtitle">轻松注册，时间灵活</p>
            <p class="subtitle">只需一台联网的电脑即可开始远程工作</p>
            <p class="subtitle">社会热点话题，提供先人一步的成长机会</p>
            <p class="subtitle">科学的薪资设计，保障长期稳定的兼职收益</p>
            <div class="flex btns-groups">
              <div class="ls-button need-button" @click="handleToDatabee">
                免费注册
                <img src="../assets/images/button-icon-01.png" />
              </div>
              <div class="ls-button need-register" @mouseover="showMore = true" @mouseleave="showMore = false">
                了解更多
                <img src="../assets/images/button-icon-03.png" />
              </div>
              <div class="ls-button-popup" v-if="showMore">
                <img src="../assets/qrcodes/2_Databee_officialaccount.jpg" />
              </div>
            </div>
          </div>
          <div class=" col-md-6 col-sm-12 col-xs-12 wow slideInRight join-us">
            <img src="../assets/images/join.png" class="mockup" />
          </div>
        </div>
        <div class="row benefit-row">
          <div class="benefit-box col-md-4 col-sm-12">
            <div class="benefit text-center">
              <img src="../assets/images/join-01.png" />
              <div class="title">10万+高校学生参与</div>
              <div class="subtitle">零距离感受民生热点话题</div>
              <div class="subtitle">免费学习数据分析相关课程</div>
              <div class="subtitle">高含金量实习证明与荣誉证书</div>
            </div>
          </div>
          <div class="benefit-box col-md-4 col-sm-12">
            <div class="benefit text-center">
              <img src="../assets/images/join-02.png" />
              <div class="title">灵活就业 闲时挣钱</div>
              <div class="subtitle">海量调查任务待您承接</div>
              <div class="subtitle">时间自由，足不出户</div>
              <div class="subtitle">稳定收入，挣钱超省心</div>
            </div>
          </div>
          <div class="benefit-box col-md-4 col-sm-12">
            <div class="benefit text-center">
              <img src="../assets/images/join-03.png" />
              <div class="title">安全无风险</div>
              <div class="subtitle">远程工作，轻松操作</div>
              <div class="subtitle">电脑拨号，安全可靠</div>
              <div class="subtitle">薪酬透明，按时发放</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="show">
      <div class="title-divider text-center">
        <div class="title">STORIES OF DATABEE</div>
        <div class="subtitle">
          <div class="left-divider"></div>
          听数据蜂说
          <div class="right-divider"></div>
        </div>
      </div>
      <div id="swiper" class="container-fuild">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, i) in swiperList">
              <div class="show-text">
                {{ item.content }}
              </div>
              <div class="show-user">
                <img :src="item.img" />
                <div>{{ item.name }}</div>
              </div>
            </div>
          </div>
          <!-- Add Pagination -->
          <div class="swiper-pagination"></div>
        </div>
      </div>

    </div>

    <div class="menu ">
      <div class="container container2">
        <div class="row menu-row">
          <div class="menu-box col-md-6 col-sm-12">
            <img class="menu-img" src="../assets/images/menu-01.png" />
            <p class="menu-title text-center">我有调查需求</p>
            <p class="menu-step text-center">发布需求 ＞ 设计调查方案 ＞ 签订合同 ＞ 执行项目</p>
            <div class="ls-button need-button" @click="handleToRelease">
              免费发布
              <img src="../assets/images/button-icon-01.png" />
            </div>
          </div>
          <div class="menu-line"></div>
          <div class="menu-box col-md-6 col-sm-12">
            <img class="menu-img" src="../assets/images/menu-02.png" />
            <p class="menu-title text-center">我要加入数据蜂当访员</p>
            <p class="menu-step text-center">注册 ＞ 完成岗位培训 ＞ 进入调查广场</p>
            <div class="ls-button need-button need-register" @click="handleToDatabee">
              快速注册
              <img src="../assets/images/button-icon-02.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <LsFooter></LsFooter>
  </div>
</template>
<script>
import Swiper from "swiper";
import { WOW } from 'wowjs';
export default {
  data () {
    return {
      swiperList: [
        {
          img: require("@/assets/images/user-01.png"),
          path: "",
          name: '倪同学',
          content: '实践出真知，没有调查就没有发言权！社会科学不是停留在纸面的知识，而是专业精神、科学方法与灵活应变的结合，更是深入实践、接触人群获得的鲜活、具体的技巧和领悟。未来我也愿意更多从事电话以及实地的访谈、调研，锻炼自我的同时更广阔地把握国情、民情与人情，有更深入、精准的提炼，逐渐成为一名合格的社科人。',
        },
        {
          img: require("@/assets/images/user-04.png"),
          path: "",
          name: '黄同学',
          content: '如果你要问我从你那里得到了什么，我会毫不犹豫的回答“一群志同道合的朋友，一句句优秀督导的教导，一辈子都再也丢不到的坚持与耐心”我们在气氛群中有来自五湖四海的朋友畅聊访问中的趣事，互相学习经验共同进步。',
        },
        {
          img: require("@/assets/images/user-02.png"),
          path: "",
          name: '杨先生',
          content: '疫情之下，我想没有什么比数据蜂能让人更自由的工作了，由于我是自由职业者，在数据蜂工作的时间可以由我支配，访问操作很简单，而且收入比较稳定，也不需要像给别人打工那样，看人脸色，只要按要求访问，就会有不错的月收入。',
        },
        {
          img: require("@/assets/images/user-03.png"),
          path: "",
          name: '马女士',
          content: '我是一名全职妈妈，已经在数据蜂平台工作几年了，这个工作出勤时间由我自己决定，而且不需要舟车劳顿去上班，我能利用我闲散的时间挣钱，也不会耽误我带两个娃和照顾老人，而且都是利国利民的项目，赚钱很踏实，项目组老师沟通顺畅，我还会一直工作下去，并推荐给更多的人。',
        },
      ],

      showContact: false,
      showMore: false
    }
  },
  computed: {
    year() {
      return new Date().getFullYear() - 2008;
    }
  },
  mounted () {
    var swiper = new Swiper('.swiper-container', {
      autoplay: true,
      // loop: true,
      slidesPerView: 'auto',
      spaceBetween: 30,
      effect: "cards",
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 10,
      mobile: true,
      live: true
    })
    wow.init();


    // $(function () {
    //   //适配火狐
    //   var t = window.devicePixelRatio
    //   var z = 1 / t;
    //   var zoom = z <= 0.75 ? 0.75 : z
    //   $('.container2').css('-moz-transform', "scale(" + zoom + ")")
    // })
  },
  methods: {

    handleToRelease () {
      this.$router.push('/release_need')
    },
    handleToDatabee () {
      if (location.origin.includes('test')) {
        window.open('https://testnsrc.databeehub.cn/dist/index.html#/user/index')
      } else {
        window.open('https://nsrc.databeehub.cn/dist/index.html#/user/index')
      }
    }
  }
}
</script>
<style scoped>
#home {
  overflow-x: hidden;
}

.header {
  position: relative;
  width: 100%;
  /* height: 1080px; */
  padding-bottom: 40px;
  background: url(../assets/images/bg-01.png);
  background-position: center center;
  background-size: cover;
}

.header .title {
  margin-top: 114px;
  width: 100%;
  max-width: 597px;
}

.header .decorate {
  position: absolute;
  left: 200px;
  top: 50px;
}

.header .subtitle {
  font-size: 24px;
  font-weight: bold;
  color: #624100;
  line-height: 32px;
  margin-top: 23px;
}

.introduce {
  align-items: center;
  float: left;
  margin: 12px 12px 8px 0;
}

.introduce img {
  margin-right: 6px;
}

.introduce p {
  color: #553C07;
  margin-bottom: 0;
}

.introduce p:first-child {
  font-size: 18px;
  font-weight: bold;
}

.introduce p:last-child {
  font-size: 16px;
  font-weight: 400;
}

.needs-row {
  position: relative;
  margin-top: 88px;
  z-index: 8;
}

.needs-row .need {
  position: relative;
  height: 266px;
  margin-bottom: 10px;
  padding: 41px 0 0 80px;
  border: 1px solid #F1E6CF;
}

.need .need-title {
  position: relative;
  font-size: 24px;
  font-weight: bold;
  color: #473203;
  margin-bottom: 20px;
  z-index: 7;

}

.need .need-item {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 400;
  color: #5B5037;
  letter-spacing: 2px;
  margin-bottom: 5px;
}

.need .need-item img {
  margin-right: 6px;
}

.need .ls-button {
  position: absolute;
  right: 40px;
  bottom: 40px;
}

.need-button {
  color: #FFFFFF;
  background: #FF6600;
  z-index: 7;
}

.need-register {
  color: #FF6600;
  background: #FFFFFF;
  border: 1px solid #FF6600;
}

.need-service {
  color: #FCC307;
  background: #FFFFFF;
  border: 1px solid #FCC307;
}


.need .need-bg {
  position: absolute;
  right: 10px;
  top: 0;
  z-index: 6;
}

.need-publish {
  background: linear-gradient(270deg, rgba(255, 230, 165, 0.5) 0%, rgba(255, 255, 255, 1) 100%);
}

.need-join {
  background: linear-gradient(90deg, #FEF4DD 0%, rgba(255, 255, 255, 1) 100%);
}

.content {
  width: 100%;
  padding: 80px 0 40px;
  background: url(../assets/images/bg-02.png);
  /* background-size: 100% 100%; */
  background-position: center center;
  background-size: cover;
}

.title-divider {}

.title-divider .title {
  font-size: 16px;
  font-family: MiSans;
  font-weight: 500;
  color: #D1D6DA;
}

.title-divider .subtitle {
  position: relative;
  font-size: 32px;
  font-weight: bold;
  color: #2A1A10;
  display: flex;
  align-items: center;
  justify-content: center;
  /* width: auto; */
}

.title-divider .left-divider {
  /* flex: 1; */
  width: 20px;
  height: 1px;
  background: #D4D4D4;
  margin-right: 10px;
}

.title-divider .right-divider {
  /* flex:1; */
  width: 20px;
  height: 1px;
  background: #D4D4D4;
  margin-left: 10px;
}

.publish-row {
  margin-top: 32px;
}

.publish-row .mockup {
  width: 100%;
}

.publish {
  padding: 40px 48px 0 40px;
}

.publish .title {
  font-size: 28px;
  font-weight: 400;
  color: #473203;
  margin-bottom: 40px;
}

.publish .subtitle {
  font-size: 18px;
  font-weight: 400;
  color: #5B5037;
  margin-bottom: 14px;
}

.publish .ls-button {
  margin-top: 28px;
}

.publish .ls-button:nth-child(1) {
  margin-right: 20px;
}

.benefit-row {
  margin-top: 80px;
  margin-bottom: 80px;
}

.benefit-row .benefit-box {
  padding: 0 15px;
  margin-bottom: 10px;
}

.benefit-row .benefit {
  height: 384px;
  background: #FFFFFF;
  box-shadow: 0px 0px 29px 2px rgba(104, 69, 0, 0.05);
  border-radius: 8px;
  padding-top: 67px;
}

.benefit-row .benefit img {
  margin: 0 auto;
}

.benefit-row .benefit .title {
  font-size: 24px;
  font-weight: bold;
  color: #473203;
  margin-bottom: 16px;
}

.benefit-row .benefit .subtitle {
  font-size: 18px;
  font-weight: 400;
  color: #5B5037;
  margin-bottom: 6px;
}

.case-row {
  max-width: 1470px;
  margin: 50px auto 0;
  /* width: 100%; */
  /* padding: 0 80px; */
}

.case-row .case-box {
  padding: 0 5px;
}

.case-row .case {
  height: 398px;
  background: #F9FAFE;
  border-radius: 8px;
  margin-bottom: 10px;
}

.case .case-head {
  height: 130px;
  font-size: 24px;
  font-weight: bold;
  color: #FFFFFF;
  padding: 28px 0 0 28px;
  background-image: url(../assets/images/case-01.png);
  background-size: 100% 100%;
}

.case .case-head-02 {
  background-image: url(../assets/images/case-02.png);
}

.case .case-head-03 {
  background-image: url(../assets/images/case-03.png);
}

.case .case-head-04 {
  background-image: url(../assets/images/case-04.png);
}

.case .case-body {
  padding: 20px 8px 0 20px;
}

.case-body img {
  height: 10px;
  margin-right: 16px;
  margin-top: 10px;
}

.case-body .case-name {
  font-size: 16px;
  font-weight: 400;
  color: #666666;
}

.case-body .case-value {
  font-size: 18px;
  font-weight: 400;
  color: #333333;
}

.case-body .case-bot {
  margin-top: 18px;
}

.join {
  padding: 80px 0 40px;
}

.join .join-us {
  padding-top: 60px;
}

.join .benefit {
  background: #F9FAFE;
}

.show {
  padding-top: 80px;
  height: 1030px;
  background: url(../assets/images/bg-03.png);
  background-position: center center;
  background-size: cover;
}

.show .subtitle {
  color: #FFFFFF;
}


.swiper-container {
  margin-top: 62px;
  padding-left: 120px;
  overflow: unset;
}

.swiper-slide {
  display: flex;
  align-items: center;
  width: 765px;
  height: 259px;
  background: #FFFFFF;
  border-radius: 8px;
  margin-right: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  padding: 0 50px;
  line-height: 28px;
}

.swiper-slide .show-user {
  margin-left: 60px;

}

.swiper-slide .show-user div {
  font-weight: bold;
  text-align: center;
  margin-top: 3px;
}

.swiper-pagination {
  bottom: -26px;
}

.menu {
  position: relative;
  padding: 80px 0 60px;
}

.menu .menu-box {
  margin-bottom: 20px;
}

.menu .menu-img {
  margin: 0 auto 20px;
}

.menu .menu-title {
  font-size: 24px;
  font-family: AlibabaPuHuiTiM;
  font-weight: 600;
  color: #000000;
  margin-bottom: 26px;
}

.menu .menu-step {
  font-size: 18px;
  font-weight: 400;
  color: #333333;
  margin-bottom: 23px;
}

.menu .ls-button {
  max-width: 140px;
  margin: 0 auto;
}

.menu .menu-line {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 2px;
  height: 60%;
  /* height: 399px; */
  background: linear-gradient(0deg, #EDF1FA 0%, #D2DCFC 49%, #EEF2FE 100%);
}




@media (min-width:1200px) and (max-width:1600px) {
  /* .container2 {
    width: 1020px;
  } */
}

@media (max-width: 768px) {
  .header {
    background-image: url(../assets/images/bg-01-xs.png);
  }
  .header .title {
    margin-top: 28px;
  }

  .header .subtitle {
    font-size: 18px;
    margin-top: 12px;
  }

  .introduce {
    width: 100%;
    /* padding-left: 20%; */
  }

  .needs-row {
    margin-top: 64px;
  }

  .needs-row .need {
    padding: 24px 0 0 28px;
  }

  .need .need-button {
    right: 24px;
    bottom: 20px;
  }

  .publish {
    padding: 20px;
  }

  .case-row {
    padding: 0;
  }

  .mockup {
    margin-top: 20px;
  }

  .btns-groups {
    position: relative;
    justify-content: center;
  }

  .swiper-container {
    padding-left: 0;
    margin-left: 10px;
    margin-right: 10px;
  }

  .swiper-slide {
    height: auto;
    width: 100%;
    padding: 10px;
    margin-right: 0;
  }

  .swiper-slide .show-user {
    margin-left: 10px;
  }

  .menu .menu-box {
    margin-bottom: 60px;
  }

  .menu .menu-line {
    display: none;
  }

  .show {
    background-image: url(../assets/images/bg-03-xs.png);
  }

}
</style>


// WEBPACK FOOTER //
// src/view/index.vue